import { ActivationLoadingScreen } from "../ActivationLoadingScreen";
import { OptInBarComponent } from "./OptInBarComponent";
import { useOptInBarContent } from "./useOptInBarContent";

export const OptInBar = () => {
  const barProps = useOptInBarContent();

  if (!barProps) return null;

  return (
    <>
      <ActivationLoadingScreen />
      <OptInBarComponent {...barProps} />
    </>
  );
};
